import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h2 className="centered-heading">Política de Privacidad</h2>

      <h3 className="heading-three">Política de Privacidad - Lexik.app</h3>
      <p className="p-color">Última actualización: 1 Mayo 2025</p>
      <br />
      <p className="p-color">
        <b>Lexik.app</b> valora la privacidad de sus usuarios y se compromete a
        proteger la información personal que recopilamos a través de nuestra
        página de pre-lanzamiento (pre-landing page). Esta Política de
        Privacidad describe cómo recopilamos, utilizamos, almacenamos y
        protegemos los datos personales proporcionados por nuestros usuarios. Al
        utilizar nuestra pre-landing page, aceptas los términos de esta
        política.
      </p>
      <ol>
        <li>
          <b>Información que Recopilamos</b>
          <p className="p-color">
            Podemos recopilar las siguientes categorías de información personal
            cuando visitas nuestra pre-landing page o interactúas con nosotros:
          </p>
          <ol>
            <li>
              <b>Información proporcionada por el usuario:</b>
              <ul>
                <li>
                  <p className="p-color">
                    Nombre y correo electrónico (cuando te registras en nuestra
                    lista de espera o para recibir notificaciones).
                  </p>
                </li>
              </ul>
            </li>

            <li>
              <b>Información técnica:</b>
              <ul>
                <li>
                  <p className="p-color">
                    Dirección IP, tipo de dispositivo, sistema operativo, tipo
                    de navegador, y patrones de navegación.
                  </p>
                </li>
                <li>
                  <p className="p-color">
                    Cookies y tecnologías de seguimiento similares (ver la
                    sección de Cookies para más detalles).
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <b>Uso de la Información Recopilada</b>
          <p className="p-color">
            Utilizamos la información personal recopilada para los siguientes
            propósitos:
          </p>
          <ol>
            <li>
              <b> Comunicaciones:</b>
              <ul>
                <li>
                  <p className="p-color">
                    Enviar actualizaciones sobre el lanzamiento de{" "}
                    <b>Lexik.app,</b> promociones, y otra información relevante
                    sobre el producto.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <b>Mejora de la experiencia del usuario:</b>
              <ul>
                <li>
                  <p className="p-color">
                    Analizar el comportamiento en la página para mejorar el
                    diseño y la funcionalidad de la pre-landing page.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <b>Propósitos legales:</b>
              <ul>
                <li>
                  <p className="p-color">
                    Cumplir con nuestras obligaciones legales y normativas.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <b>Uso de Cookies y Tecnologías de Seguimiento</b>
          <p className="p-color">
            <b>Lexik.app</b> utiliza cookies y tecnologías de seguimiento para
            recopilar datos sobre tu actividad en nuestra pre-landing page. Esto
            incluye:
          </p>
          <ol>
            <li>
              <p className="p-color">
                <b>Cookies de sesión:</b> Que permiten que el sitio funcione
                correctamente y mejoran la experiencia del usuario.
              </p>
            </li>
            <li>
              <p className="p-color">
                <b>Cookies de terceros:</b> Para propósitos de analítica (por
                ejemplo, Google Analytics) y marketing.
              </p>
            </li>
          </ol>
          <p className="p-color">
            Tienes la opción de aceptar o rechazar el uso de cookies a través
            del banner de consentimiento cuando visitas la página. También
            puedes desactivar las cookies modificando la configuración de tu
            navegador, aunque esto podría afectar el funcionamiento de algunas
            características del sitio.
          </p>
        </li>
        <li>
          <b>Compartición de Información con Terceros</b>
          <p className="p-color">
            No compartimos ni vendemos información personal a terceros, excepto
            en los siguientes casos:
          </p>
          <ol>
            <li>
              <p className="p-color">
                <b>Proveedores de servicios:</b> Podemos compartir datos con
                proveedores de confianza que nos ayudan con servicios como el
                análisis de tráfico o el envío de correos electrónicos, siempre
                en cumplimiento con esta política de privacidad.
              </p>
            </li>
            <li>
              <p className="p-color">
                <b>Requisitos legales:</b> En caso de ser requerido por ley o
                para cumplir con un proceso judicial, como una orden judicial o
                una citación legal.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <b>Almacenamiento y Seguridad de los Datos</b>
          <p className="p-color">
            <b>Lexik.app</b> se compromete a proteger la información personal
            que recopilamos utilizando medidas de seguridad técnicas y
            organizativas apropiadas. Estas medidas están diseñadas para evitar
            el acceso no autorizado, alteración, divulgación o destrucción de tu
            información personal.
          </p>
          <p className="p-color">
            Sin embargo, ninguna transmisión de datos por internet es
            completamente segura. Aunque hacemos todo lo posible por proteger tu
            información, no podemos garantizar la seguridad absoluta de los
            datos transmitidos a través de nuestra página.
          </p>
        </li>
        <li>
          <b>Derechos del Usuario</b>
          <p className="p-color">
            De acuerdo con la normativa aplicable en protección de datos, tienes
            los siguientes derechos sobre tu información personal:
          </p>
          <ol>
            <li>
              <p className="p-color">
                <b>Acceso:</b> Puedes solicitar acceso a los datos personales
                que tenemos sobre ti.
              </p>
            </li>
            <li>
              <p className="p-color">
                <b>Rectificación:</b> Puedes solicitar que corrijamos cualquier
                información personal inexacta o incompleta.
              </p>
            </li>
            <li>
              <p className="p-color">
                <b>Eliminación:</b> Tienes derecho a solicitar la eliminación de
                tu información personal cuando ya no sea necesaria para los
                fines para los que fue recopilada.
              </p>
            </li>
            <li>
              <p className="p-color">
                <b>Retiro del consentimiento:</b> Puedes retirar tu
                consentimiento para el uso de tus datos personales en cualquier
                momento. Esto no afectará la legalidad del procesamiento basado
                en el consentimiento antes de su retiro.
              </p>
            </li>
          </ol>
          <p className="p-color">
            Para ejercer estos derechos, por favor, contáctanos a través del
            correo{" "}
            <b>
              <Link
                className="text-decoration-none p-color"
                to={"mailto: legal@lexik.app"}
              >
                {" "}
                legal@lexik.app{" "}
              </Link>
            </b>
          </p>
        </li>
        <li>
          <b>Conservación de los Datos</b>
          <p className="p-color">
            Conservaremos tu información personal solo durante el tiempo
            necesario para cumplir con los fines descritos en esta Política de
            Privacidad, a menos que se requiera o permita un período de
            retención más largo por ley.
          </p>
        </li>
        <li>
          <b>Cambios en la Política de Privacidad</b>
          <p className="p-color">
            Podemos actualizar esta Política de Privacidad periódicamente para
            reflejar cambios en nuestras prácticas o en las normativas
            aplicables. Te notificaremos cualquier cambio importante a través de
            nuestra página o por correo electrónico (si estás suscrito),
            indicando la fecha de la última actualización.
          </p>
        </li>
        <li>
          <b>Contacto</b>
          <p className="p-color">
            Si tienes preguntas o inquietudes sobre esta Política de Privacidad
            o sobre cómo manejamos tus datos personales, puedes contactarnos a
            través de:
          </p>
        </li>
      </ol>
      <br />
      <div className="contact-info">
        <p className="p-color">Antonia Koch</p>
        <p className="p-color">c/o Grosch Postflex #1270</p>
        <p className="p-color">Emsdettener Str. 10</p>
        <p className="p-color">48268 Greven</p>
        <p className="p-color">
          <Link
            className="text-decoration-none p-color"
            to={"mailto: legal@lexik.app"}
          >
            {" "}
            legal@lexik.app{" "}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
